import { createUseStyles } from 'react-jss';

import { theme } from '@align-cpf/uikit-styles';
const { colors, spacing } = theme;

export default createUseStyles(
  {
    root: {
      display: 'flex',
      columnGap: spacing.sp02,
      padding: [spacing.sp03, spacing.sp04],
      color: colors.textPrimary,
      transition: 'outline .2s ease-out',
      cursor: 'pointer',
      outline: [1, 'solid', 'transparent'],
      outlineOffset: -1,
      boxSizing: 'border-box',
      flexWrap: 'wrap',
      '&:hover': {
        backgroundColor: colors.backgroundSubtleHover,
      },
      '&:active': {
        backgroundColor: colors.backgroundSubtleActive,
      },
      '&:focus-visible': {
        outlineColor: colors.borderFocus,
      },
    },

    disabled: {
      color: colors.textDisabled,
      pointerEvents: 'none',
    },

    label: {
      pointerEvents: 'none',
    },

    subtext: {
      color: colors.textSecondary,
      flexBasis: '100%',
    },

    selected: {
      backgroundColor: colors.backgroundSubtleActive,
    },

    checkbox: {
      margin: 0,
      display: 'inline',
    },

    icon: {},

    avatar: {
      width: 20,
      height: 20,
      borderRadius: '50%',
    },

    icons: {
      display: 'flex',
      columnGap: spacing.sp02,
      height: 20,
      alignItems: 'center',
    },

    content: {},
  },
  {
    name: 'Option',
  },
);
